import React from 'react';
import VoxelCheckbox from '../../../../../components/voxel/Forms/VoxelCheckbox';
import { ContentKeywordGq } from '../../../../../graphql/projects/models/ContentKeywordGq';
import { ContentKeywordSelecting } from '../../../../../graphql/projects/models/ContentKeywordSelectingGq';

export interface RowCheckboxProps {
  contentKeyword: ContentKeywordGq;
  selectionState: ContentKeywordSelecting;
  disabled?: boolean;
}

const RowCheckbox: React.FC<RowCheckboxProps> = React.memo(
  ({ contentKeyword, selectionState, disabled }) => {
    // These are memoized because the component is wrapped in React.memo
    const clicked = !!selectionState.contentKeywordIds[contentKeyword.id];
    const selected = selectionState.invertSelection ? !clicked : clicked;

    return (
      <VoxelCheckbox color='primary' checked={selected} disabled={disabled} />
    )
  }
);

export default RowCheckbox;
